document.addEventListener('DOMContentLoaded', () => {
  const modalId = 'modal-pdf-viewer'
  const modal = document.getElementById(modalId)
  const container = document.getElementById('flipbook')
  const bookBtn = document.querySelector('.modal-book-btn')
  const downloadBtn = document.querySelector('.modal-download-btn')

  if (!modal || !container) {
    return
  }

  const elements = document.querySelectorAll('a[href*=".pdf"]')
  elements.forEach((el) => {
    el.setAttribute('data-pdf-url', el.href)
    el.setAttribute('data-bs-toggle', 'modal')
    el.target = '_self'
    el.href = `#${modalId}`
  })

  // Nettoyage au close
  modal.addEventListener('hidden.bs.modal', () => {
    container.innerHTML = ''
  })

  document.querySelectorAll('a[data-pdf-url]').forEach((link) => {
    link.addEventListener('click', async (e) => {
      e.preventDefault()

      const pdfUrl = link.getAttribute('data-pdf-url')
      const bookUrl = link.getAttribute('data-book-url')
      if (bookBtn && bookUrl && bookUrl.length > 0) {
        bookBtn.href = bookUrl

        if (bookUrl.includes('#modal-')) {
          bookBtn.setAttribute('data-bs-toggle', 'modal')
          bookBtn.target = '_self'
        } else if (bookUrl.includes('http')) {
          bookBtn.target = '_blank'
        }
      }

      if (downloadBtn && pdfUrl && pdfUrl.length > 0) {
        downloadBtn.href = pdfUrl
      }

      modal.classList.add('loading')

      try {
        const loadingTask = pdfjsLib.getDocument(pdfUrl)
        const pdf = await loadingTask.promise

        const pagesContainer = document.createElement('div')
        pagesContainer.className = 'pdf-pages-container'
        container.appendChild(pagesContainer)

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i)
          const viewport = page.getViewport({
            scale: 1
          })

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')
          canvas.width = viewport.width
          canvas.height = viewport.height
          canvas.className = 'pdf-page-canvas'

          const renderTask = page.render({
            canvasContext: context,
            viewport
          })

          if (i === 1) {
            renderTask.promise.then(() => {
              modal.classList.remove('loading')
            })
          }

          await renderTask.promise

          const pageDiv = document.createElement('div')
          pageDiv.className = 'pdf-page'
          pageDiv.appendChild(canvas)
          pagesContainer.appendChild(pageDiv)
        }

        modal.classList.remove('loading')
      } catch (err) {
        container.innerHTML = `
          <div class="pdf-error">
            <p>Erreur de chargement du PDF</p>
            <p>${err.message}</p>
          </div>
        `
        modal.classList.remove('loading')
      }
    })
  })
})
